module.exports = __webpack_public_path__ + "img/img-3mobile.00922902.webp";